import { render, staticRenderFns } from "./ApprovalTypeApproversComponent.vue?vue&type=template&id=44eaead6"
import script from "./ApprovalTypeApproversComponent.vue?vue&type=script&lang=js"
export * from "./ApprovalTypeApproversComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports